import enUS from './en-us.json';
import frFR from './fr-fr.json';
import es from './es.json';
import ptBR from './pt-br.json';

export default {
    'en-us': enUS,
    es: es,
    'fr-fr': frFR,
    'pt-br': ptBR
};
